const makeInternationalPhoneNumber = (phoneCountryCode, phoneNumber) => {
  return phoneCountryCode + phoneNumber
}

const normalizePhoneNumber = (phoneNumber, countryCallingCode) => {
  // Remove non-digit characters from countryCallingCode
  const normalizedCountryCallingCode = countryCallingCode.replace(/\D/g, '')

  if (phoneNumber.startsWith(normalizedCountryCallingCode)) {
    return phoneNumber.slice(normalizedCountryCallingCode.length)
  }

  if (phoneNumber.startsWith('0')) {
    return phoneNumber.slice(1)
  }

  return phoneNumber
}

export { makeInternationalPhoneNumber, normalizePhoneNumber }
